import { ODATA_EXPORT_NAME_SEPARATOR_REGEX } from '@/tools/viewODataExports/oDataExports.constants';
import type { ViewODataExportItem } from '@/tools/viewODataExports/viewODataExports.types';

/**
 * Returns one item per export id, keeping the most recent value seen for each id.
 */
export const uniqODataExportsById = (items: ViewODataExportItem[]) => {
  const itemsById = new Map<string, ViewODataExportItem>();

  items.forEach((item) => {
    itemsById.set(item.id, item);
  });

  return Array.from(itemsById.values());
};

/**
 * Returns a new array sorted by export name.
 */
export const sortODataExportsByExportName = (items: ViewODataExportItem[]) =>
  items.slice().sort((left, right) => left.exportName.localeCompare(right.exportName));

/**
 * Partition the export name to extract the user provided name and the unique export
 * identifier segment
 *
 * @param {string} exportName - The OData export name not altered to be Odata character safe
 *
 * @returns {object} - The partitioned export name
 */
export function getODataExportNameParts(exportName: string): { name: string; guid: string; capsule: string } {
  const matches = exportName.match(ODATA_EXPORT_NAME_SEPARATOR_REGEX);
  if (matches && matches.length >= 4) {
    const name = matches[1];
    // Disregard matches[2] which is the worksheet name
    const guid = matches[3];
    const capsule = matches[4] || '';
    return { name, guid, capsule };
  }
  return { name: exportName, guid: '', capsule: '' };
}
